import React, { useState, useEffect } from 'react';

import ConditionBar from "@dndComponents/other/ConditionBar";

import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  active_conditions: { [id: string]: { level: number, source_true_id: string } };
  starred: string[];
  immune: string[];
  extra_ids: string[];
  disabled: boolean;
  color?: string;
  menu_open: boolean;
  onChange: (active_conditions: { [id: string]: { level: number, source_true_id: string } }, starred: string[], immune: string[]) => void;
}

const ConditionSideBar: React.FC<Props> = ({
  active_conditions: initialActiveConditions,
  starred: initialStarred,
  immune: initialImmune,
  menu_open: initialMenuOpen,
  extra_ids,
  disabled,
  color = 'lightgray',
  onChange
}) => {
  const [activeConditions, setActiveConditions] = useState(initialActiveConditions);
  const [starred, setStarred] = useState(initialStarred);
  const [immune, setImmune] = useState(initialImmune);
  const [menuOpen, setMenuOpen] = useState(initialMenuOpen);

  useEffect(() => {
    setMenuOpen(initialMenuOpen);
  }, [initialMenuOpen]);

  const renderAllConditions = () => {
    if (!menuOpen) return null;

    return (
      <ConditionBar 
        active_conditions={activeConditions}
        starred={starred}
        immune={immune}
        extra_ids={extra_ids}
        disabled={disabled}
        color={color}
        onChange={(condition_id: string, level: number) => {
          const newActiveConditions = { ...activeConditions };
          
          if (level === 0) {
            delete newActiveConditions[condition_id];
          } else {
            if (newActiveConditions[condition_id]) {
              newActiveConditions[condition_id].level = level;
            } else {
              newActiveConditions[condition_id] = {
                level: level,
                source_true_id: ""
              }
            }
          }
          setActiveConditions(newActiveConditions);
        }}
        onStar={(id: string) => {
          setStarred(prev => 
            prev.includes(id) 
              ? prev.filter(o => o !== id)
              : [...prev, id]
          );
        }}
        onImmune={(id: string) => {
          setImmune(prev => 
            prev.includes(id)
              ? prev.filter(o => o !== id)
              : [...prev, id]
          );
        }}
      />
    );
  };

  return (
    <ModalOrDrawer
      open={menuOpen}
      onClose={() => {
        setMenuOpen(false);
        onChange(activeConditions, starred, immune);
      }}>
      {renderAllConditions()}
    </ModalOrDrawer>
  );
};

export default ConditionSideBar;
